/*
 * A FAQ section's custom CSS, on the page the embed draws the section in.
 *
 * faqs.jsx draws a section in its own design, a template's (templated.js) or
 * the classic one (FAQSection.jsx, FullFAQSection.jsx), and either way adds the
 * CSS its owner wrote for it, so a customer's page shows what the design
 * studio previewed. A section inside the help center's own pages (an article,
 * the v2 Faqs block) takes the help center's look instead: those mount the
 * classic renderer directly and never come through here.
 */

const CUSTOM_CSS_MARKER = 'data-hcfq-custom-css';

/**
 * A `<style>` element holding `css` as text, tagged with `marker`.
 *
 * textContent, never markup: custom CSS is text a site admin typed, and a
 * `</style>` in it must not be able to end the element.
 */
export function styleElement(doc, css, marker) {
    const style = doc.createElement('style');
    style.textContent = css;
    style.setAttribute(marker, '');
    return style;
}

/**
 * Add a section's custom CSS to the end of `element`, the placeholder it is
 * drawn in. A section without any adds nothing.
 *
 * @param {HTMLElement} element  the page's `.hc-faq-section` placeholder
 * @param {Object} section       the payload's `section`
 * @returns {HTMLStyleElement|null}
 */
export function appendCustomCss(element, section) {
    const customCss = section && section.options ? section.options.customCss : null;
    if (typeof customCss !== 'string' || customCss.trim() === '') {
        return null;
    }

    return element.appendChild(styleElement(element.ownerDocument, customCss, CUSTOM_CSS_MARKER));
}
